export const WIZARD_BASE_COMMAND = 'npx @memaraio/wizard';
